import React from 'react'
import { useAuthenticationContext } from '../context/AuthenticationContext'

const HeaderUser = () => {
  const { login, isAuthenticated, loadingAuth, userData, logout, error } = useAuthenticationContext()

  const clickLogout = (e: any) => {
    e.preventDefault()
    logout()
  }

  const clickLogin = (e: any) => {
    e.preventDefault()
    login()
  }

  if (loadingAuth) {
    return <span className="userName">Načítám...</span>
  }

  if (isAuthenticated) {
    return (
      <>
        <span className="userName">
        {userData?.jmena} {userData?.prijmeni}
        </span>

        <span
          onClick={clickLogout}
          className="btnLogin">
          Odhlásit
        </span>
      </>
    )
  }

  return (
    <>
      {error && (
        <div className="authError">
          <div className="authError-header">
            <span>Chyba přihlášení</span>
          </div>
          <div className="authError-body">
            {error}
          </div>
        </div>
      )}
      <span
        onClick={clickLogin}
        className="btnLogin">
      Přihlásit
    </span>
    </>
  )
}

export default HeaderUser
